<template>
    <div class="p-3">
        <el-card header="Afiliados">

            <el-row class="py-2">
                <h5 class="v-col-6 v-col-md-9 me-3">Ordenar por</h5>
                <div class="v-col-6 v-col-md-3">
                    <el-radio-group v-model="status">
                        <el-radio value="balance-asc" border>Menor saldo</el-radio>
                        <el-radio value="balance-desc" border>Maior saldo</el-radio>
                        <el-radio value="desc" border>Mais recentes</el-radio>
                        <el-radio value="asc" border>Mais antigos</el-radio>
                    </el-radio-group>
                </div>
            </el-row>

            <PaginatedTable :loading="loading" :page="data.current_page" :show-rows="10" :pages="data.last_page" :data="data.data" :cols="[
            ]" @change="changePage">
                <el-table-column label="Nome" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.user.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Contacto" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.user.phone }}
                    </template>
                </el-table-column>
                <el-table-column label="Saldo total" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.balance.toFixed(2)}}MT
                    </template>
                </el-table-column>
                <el-table-column label="Afiliado desde" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ new Date(data.row.created_at).toLocaleDateString() }}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" @click="openAffiliate(data.row)" icon="View" title="Ver mais"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PaginatedTable>
        </el-card>

        <ModalComponent v-if="affiliate" @close="() => {affiliate = null}" cardclass="col-12 col-md-6 col-lg-5 col-x-lg-4" header="Informações do pedido">
            <AffiliateView :affiliate="affiliate"  />
        </ModalComponent>
    </div>
</template>

<script lang="ts" setup>
    import Api from '@/services/api'
    import { onBeforeMount, watch } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElMessageBox, ElRow } from 'element-plus';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import { Affiliate } from '@/services/types/affiliate';
    import AffiliateView from '@/components/modals/views/AffiliateView.vue';
    import ModalComponent from '@/components/modals/ModalComponent.vue';

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Affiliate>>(defaultPaginated)
    const status = ref<'balance-asc' | 'balance-desc' | 'desc' | 'asc'>('desc')
    const affiliate = ref<Affiliate | null>(null)
    const page = ref<number>(1)

    const getAffiliates = async () => {
        console.log("Okay")
        loading.value = true
        console.log(status.value)
        const res = await Api.get(`admin/affiliates?page=${page.value}&status=${status.value}`)
        if (res.status == 200) {
            data.value = res.data.affiliates
            console.log(res.data)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            console.log(res)
        }
        loading.value = false
    }

    const changePage = (p: number) => {
        page.value = p
        getAffiliates()
    }

    const openAffiliate = (row: any) => {
        // okay
        affiliate.value = row
    }

    onBeforeMount(() => {
        getAffiliates()

        document.title = "Afiliados"
    })

    watch(status, () => {
        page.value = 1
        getAffiliates()
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
